import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchDashboardCountRequest } from "../ipsStore/actions";
import GenericDashboardScreen from "../components/GenericDashboardScreen";
import PreIntimationIcon from "../../../assets/images/PreIntimation.svg";
import DashboardBG from "../../../assets/images/Dashboard_bg.svg";

const PreIntimation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCardClick = (label) => {
    navigate(
      `/pre_intimation-patient_list?label=${encodeURIComponent(label)}`,
      {
        state: { label },
      }
    );
  };

  const handleDateFilterApply = (dateRange) => {
    let payload = new FormData();
    payload.append("from_date", dateRange.fromDate);
    payload.append("to_date", dateRange.toDate);
    payload.append("screen", "pre_intimation");
    payload.append("source", "Web");
    dispatch(fetchDashboardCountRequest(payload));
  };

  return (
    <GenericDashboardScreen
      header="Pre-Intimation"
      screenIcon={PreIntimationIcon}
      iconUrl={"/home"}
      showDateFilters={true}
      bgImage={DashboardBG}
      fetchAction={fetchDashboardCountRequest}
      dataSelector={(state) => state.ips.dashboardCount?.pre_intimation}
      screenName="pre_intimation"
      handleCardClick={handleCardClick}
      dateFilterHandler={handleDateFilterApply}
    />
  );
};

export default PreIntimation;
